import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AdminProjectTemplate,
  CreateAdminProjectTemplate,
  EditAdminProjectTemplate,
} from './models/admin-project-template.model';

const BASE_URL = `${environment.apiConfig.url}/admin/project-templates`;

@Injectable()
export class AdminProjectTemplateService {
  constructor(private http: HttpClient) {}

  loadTemplates(): Observable<AdminProjectTemplate[]> {
    const filterParams = {
      where: {
        datetimeDeleted: null,
      },
    };
    const url = `${BASE_URL}?${new URLSearchParams({ filter: JSON.stringify(filterParams) })}`;
    return this.http.get<AdminProjectTemplate[]>(url);
  }

  loadTemplate(templateId: number): Observable<AdminProjectTemplate> {
    const url = `${BASE_URL}/${templateId}`;
    return this.http.get<AdminProjectTemplate>(url);
  }

  addTemplate(template: CreateAdminProjectTemplate): Observable<AdminProjectTemplate> {
    return this.http.post<AdminProjectTemplate>(BASE_URL, template);
  }

  deleteTemplate(templateId: number) {
    const url = `${BASE_URL}/${templateId}`;
    return this.http.delete<void>(url);
  }

  updateTemplate(
    templateId: number,
    template: EditAdminProjectTemplate,
  ): Observable<AdminProjectTemplate> {
    const url = `${BASE_URL}/${templateId}`;
    return this.http.patch<AdminProjectTemplate>(url, template);
  }
}
